export function signInRequest(email, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { email, password },
  };
}

export function signInSuccess(token, user) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user },
  };
}

export function signUpRequest(organization, name, email, emailConfirm, password, passwordConfirm, birth) {
  return {
    type: '@auth/SIGN_UP_REQUEST',
    payload: { organization, name, email, emailConfirm, password, passwordConfirm, birth },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}
